import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryMenstrualNatureDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualNature/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryMenstrualNatureList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualNature/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryMenstrualNature = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualNature/Create`, data);

export const UpdateRefHistoryOBGyHistoryMenstrualNature = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualNature/Update`, data);

export const DeleteRefHistoryOBGyHistoryMenstrualNature = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryMenstrualNature/Delete`, data);